import React from 'react'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'

import rootReducer from '../reducers'
import configureStore from 'Shared/configureStore'
import EmployeeContainer from './EmployeeContainer'


const EmployeeRoot = ({
  fetchInitialDataURL,
}) => {
  const state = {
    misc: {
      fetchInitialDataURL,
    },
  }

  const store = configureStore(rootReducer, state)

  return <Provider store={ store }><EmployeeContainer></EmployeeContainer></Provider>
}

EmployeeRoot.propTypes = {
  fetchInitialDataURL: PropTypes.string.isRequired,
}

export default EmployeeRoot
